import type { RecipeStep } from "@recipevault/shared";

export const MIN_WAIT = 1;
export const MAX_WAIT = 10080; // 1 week
const DEFAULT_WAIT = 60;

export function initialWaitMinutes(step: Pick<RecipeStep, "estimatedMin">): { minutes: number; fromRecipe: boolean } {
  if (step.estimatedMin && step.estimatedMin > 0) {
    return { minutes: Math.min(step.estimatedMin, MAX_WAIT), fromRecipe: true };
  }
  return { minutes: DEFAULT_WAIT, fromRecipe: false };
}

export function nudgeMinutes(current: number, deltaMinutes: number): number {
  return Math.max(MIN_WAIT, Math.min(MAX_WAIT, current + deltaMinutes));
}

export function readyTimeIso(nowMs: number, minutes: number): string {
  return new Date(nowMs + minutes * 60_000).toISOString().replace(/\.\d{3}Z$/, "Z");
}

export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}
